module.exports = __webpack_public_path__ + "img/cleanup2-7-8-2021.0c6c2af7.jpg";